import React from 'react';
import { motion } from 'framer-motion';
import { bookInfo } from '../../data/bookData';
import SectionHeading from '../SectionHeading';

const SynopsisSection = () => (
  <section className="py-24 bg-brand-dark relative border-t border-white/5">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <SectionHeading title="The Overall Arc" subtitle="Synopsis" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-brand-surface border border-white/5 rounded-2xl p-8 md:p-12 relative overflow-hidden box-glow"
      >
        <p className="text-xl md:text-2xl text-gray-300 leading-relaxed font-light text-center md:text-left">
          <span className="text-3xl text-brand-accent font-display mr-2">"</span>
          {bookInfo.overallArc}
          <span className="text-3xl text-brand-accent font-display ml-2">"</span>
        </p>
      </motion.div>
    </div>
  </section>
);

export default SynopsisSection;